module.exports = __webpack_public_path__ + "static/media/daryna_kulya.3b1ad2e0.jpeg";